export default __webpack_public_path__ + "static/media/search-input-icon.8f1a09ce.svg";